import client from './client';

export const authApi = {
  register: (payload) => client.post('/auth/register', payload).then((r) => r.data),
  // What Register.jsx needs before showing the form: whether a card is
  // required right now, the Stripe publishable key when it is, and the
  // package catalog to choose from. See SignupConfigController.
  signupConfig: () => client.get('/auth/signup-config').then((r) => r.data),
  login: (payload) => client.post('/auth/login', payload).then((r) => r.data),
  logout: () => client.post('/auth/logout').then((r) => r.data),
  forgotPassword: (payload) =>
    client.post('/auth/forgot-password', payload).then((r) => r.data),
  resetPassword: (payload) =>
    client.post('/auth/reset-password', payload).then((r) => r.data),
  // Confirm the 6-digit code from the signup email (returns a session token).
  verifyCode: (payload) => client.post('/auth/email/verify-code', payload).then((r) => r.data),
  // Send a fresh code to an unverified address.
  resendCode: (payload) => client.post('/auth/email/resend-code', payload).then((r) => r.data),
  /* ---- Social login ("Continue with Google / Facebook") ---------------- */

  // Which providers the server actually has credentials for, so the login
  // screen never renders a button that can only fail.
  socialProviders: () => client.get('/auth/social/providers').then((r) => r.data),
  // NOTE: there is no socialRedirect() here on purpose. Starting a sign-in is
  // a plain top-level navigation to GET /auth/social/{provider}/redirect, not
  // an XHR — the server sets an HttpOnly cookie on that response, and a cookie
  // from a cross-origin XHR would be discarded. See SocialAuthButtons.
  // Trade the single-use code from the callback redirect for a session token.
  // The token itself is never a URL parameter — this POST is how it arrives.
  socialExchange: (payload) => client.post('/auth/social/exchange', payload).then((r) => r.data),
  // Name + photo of a pending Facebook signup, for the "add your email" screen.
  socialPending: (payload) => client.post('/auth/social/pending', payload).then((r) => r.data),
  // Facebook signup (email is never requested from Facebook): submit one, and a 6-digit code is sent to it.
  socialComplete: (payload) => client.post('/auth/social/complete', payload).then((r) => r.data),
  // Confirm that code, which links the identity and signs the user in.
  socialConfirm: (payload) => client.post('/auth/social/confirm', payload).then((r) => r.data),

  me: () => client.get('/auth/me').then((r) => r.data),
  // NOTE: the route is PUT /auth/profile, not /auth/me.
  updateProfile: (payload) => client.put('/auth/profile', payload).then((r) => r.data),
};

export default authApi;
